import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { authHeader } from "../../common/apis/authHeader";
import axiosBaseURL from "../../common/apis/axiosBaseURL";
import HandleError from "../../common/apis/HandleError";
import { apiVersion } from "../../common/apis/apiVersion";

export const MatchCricketListingAsyncCall = createAsyncThunk(
    "match/MatchCricketListingAsyncCall",
    async (values, { rejectWithValue }) => {
        try {
            const response = await axiosBaseURL.post("/app/"+apiVersion.v1+"/match/publish_match_list", values, {
                headers: authHeader()
            });
            return response.data;
        } catch (error) {
            HandleError(error.response.data)
            return rejectWithValue(error.response.data);
        }
    }
);

export const MatchFootballListingAsyncCall = createAsyncThunk(
    "match/MatchFootballListingAsyncCall",
    async (values, { rejectWithValue }) => {
        try {
            const response = await axiosBaseURL.post("/app/"+apiVersion.v1+"/match/publish_football_list", values, {
                headers: authHeader()
            });
            return response.data;
        } catch (error) {
            HandleError(error.response.data)
            return rejectWithValue(error.response.data);
        }
    }
);

export const PoolContestAsyncList = createAsyncThunk(
    "match/PoolContestAsyncList",
    async (value) => {
        try {
            const response = await axiosBaseURL.post(`/app/${apiVersion.v1}/pool/matches/${value.type}/pool_contest_list`, value, {
                headers: authHeader()
            });
            return response.data;
        } catch (error) {
            HandleError(error.response.data)
            return error.response.data
        }
    }
);

export const PoolContestDetailAsyncList = createAsyncThunk(
    "match/PoolContestDetailAsyncList",
    async (value) => {
        try {
            const response = await axiosBaseURL.post(`app/pool/match/${value.type}/pool_detail`, value, {
                headers: authHeader()
            });
            return response.data;
        } catch (error) {
            HandleError(error.response.data)
            return error.response.data
        }
    }
);

export const MatchPlayerAsyncList = createAsyncThunk(
    "match/MatchPlayerAsyncList",
    async (value, { rejectWithValue }) => {
        try {
            const response = await axiosBaseURL.post("/app/"+apiVersion.v1+"/match/player_list", value, {
                headers: authHeader()
            });
            return response.data;
        } catch (error) {
            HandleError(error.response.data)
            return rejectWithValue(error.response.data);
        }
    }
);

export const ContestSaveTeamAction = createAsyncThunk(
    "match/ContestSaveTeamAction",
    async (value) => {
        try {
            const response = await axiosBaseURL.post("/app/"+apiVersion.v1+"/match/save_player", value, {
                headers: authHeader()
            });
            return response.data;
        } catch (error) {
            HandleError(error.response.data)
            return error.response.data
        }
    }
);

export const MyContestListAction = createAsyncThunk(
    "match/MyContestListAction",
    async (value) => {
        try {
            const response = await axiosBaseURL.post(`/app/${apiVersion.v1}/pool/matches/${value.type}/mypool`, value, {
                headers: authHeader()
            });
            return response.data;
        } catch (error) {
            HandleError(error.response.data)
            return error.response.data
        }
    }
);

export const ContestsMypicks = createAsyncThunk(
    "match/ContestsMypicks",
    async (value) => {
        try {
            const response = await axiosBaseURL.post(`/app/${apiVersion.v1}/match/${value.type}/team`, value, {
                headers: authHeader()
            });
            return response.data;
        } catch (error) {
            HandleError(error.response.data)
            return error.response.data
        }
    }
);

export const ContestPrizePreviewAction = createAsyncThunk(
    "match/ContestPrizePreviewAction",
    async (value) => {
        try {
            const response = await axiosBaseURL.post(`/app/${apiVersion.v1}/pool/confirm_join_pre`, value, {
                headers: authHeader()
            });
            return response.data;
        } catch (error) {
            HandleError(error.response.data)
            return error.response.data
        }
    }
);

export const JoinContestAction = createAsyncThunk(
    "match/JoinContestAction",
    async (value) => {
        try {
            const response = await axiosBaseURL.post(`/app/${apiVersion.v1}/pool/join_pool`, value, {
                headers: authHeader()
            });
            return response.data;
        } catch (error) {
            HandleError(error.response.data)
            return error.response.data
        }
    }
);

export const PrivateContestWinnersList = createAsyncThunk(
    "match/PrivateContestWinnersList",
    async (value) => {
        try {
            const response = await axiosBaseURL.post(`/app/${apiVersion.v1}/pool/privatecontest/contestsize`, value, {
                headers: authHeader()
            });
            return response.data;
        } catch (error) {
            HandleError(error.response.data)
            return error.response.data
        }
    }
);

export const CreatePrivatecontest = createAsyncThunk(
    "match/CreatePrivatecontest",
    async (value) => {
        try {
            const response = await axiosBaseURL.post(`/app/${apiVersion.v1}/pool/privatecontest/save`, value, {
                headers: authHeader()
            });
            return response.data;
        } catch (error) {
            HandleError(error.response.data)
            return error.response.data
        }
    }
);

export const SearchPrivatecontest = createAsyncThunk(
    "match/SearchPrivatecontest",
    async (value) => {
        try {
            const response = await axiosBaseURL.post(`/app/${apiVersion.v1}/pool/privatecontest/save`, value, {
                headers: authHeader()
            });
            return response.data;
        } catch (error) {
            HandleError(error.response.data)
            return error.response.data
        }
    }
);

export const CloneMyPicksAction = createAsyncThunk(
    "match/CloneMyPicksAction",
    async (value) => {
        try {
            const response = await axiosBaseURL.post(`/app/${apiVersion.v1}/match/${value.type}/match/clone_player_list`, value, {
                headers: authHeader()
            });
            return response.data;
        } catch (error) {
            HandleError(error.response.data)
            return error.response.data
        }
    }
);

export const getPlayerListIDAction = createAsyncThunk(
    "match/getPlayerListIDAction",
    async (value) => {
        try {
            const response = await axiosBaseURL.post(`/app/${apiVersion.v1}/match/${value.type}/user_match_player_list`, value, {
                headers: authHeader()
            });
            return response.data;
        } catch (error) {
            HandleError(error.response.data)
            return error.response.data
        }
    }
);

export const EditPicksSaveAction = createAsyncThunk(
    "match/EditPicksSaveAction",
    async (value) => {
        try {
            const response = await axiosBaseURL.post(`/app/${apiVersion.v1}/match/edit_match_player_list`, value, {
                headers: authHeader()
            });
            return response.data;
        } catch (error) {
            HandleError(error.response.data)
            return error.response.data
        }
    }
);

export const ContestMyPortfolioAction = createAsyncThunk(
    "match/ContestMyPortfolioAction",
    async (value) => {
        try {
            const response = await axiosBaseURL.post(`/app/${apiVersion.v1}/match/${value.type}/matches/myportfolio`, value, {
                headers: authHeader()
            });
            return response.data;
        } catch (error) {
            HandleError(error.response.data)
            return error.response.data
        }
    }
);

export const GetBannerListAction = createAsyncThunk(
    "match/GetBannerListAction",
    async (value) => {
        try {
            const response = await axiosBaseURL.post(`/app/${apiVersion.v1}/banners/list`, value, {
                headers: authHeader()
            });
            return response.data;
        } catch (error) {
            HandleError(error.response.data)
            return error.response.data
        }
    }
);

export const MatchResultScoreAction = createAsyncThunk(
    "match/MatchResultScoreAction",
    async (value) => {
        try {
            const response = await axiosBaseURL.post(`/app/${apiVersion.v1}/match/commentary_score_list`, value, {
                headers: authHeader()
            });
            return response.data;
        } catch (error) {
            HandleError(error.response.data)
            return error.response.data
        }
    }
);

export const MatchMyLeaderBoardPlayerListAction = createAsyncThunk(
    "match/MatchMyLeaderBoardPlayerListAction",
    async (value) => {
        try {
            const response = await axiosBaseURL.post(`/app/${apiVersion.v1}/pool/matches/user_team_player_list`, value, {
                headers: authHeader()
            });
            return response.data;
        } catch (error) {
            HandleError(error.response.data)
            return error.response.data
        }
    }
);

export const MatchSelectedPlayersAction = createAsyncThunk(
    "match/MatchSelectedPlayersAction",
    async (value) => {
        try {
            const response = await axiosBaseURL.post(`/app/${apiVersion.v1}/match/player/selected`, value, {
                headers: authHeader()
            });
            return response.data;
        } catch (error) {
            HandleError(error.response.data)
            return error.response.data
        }
    }
);

const initialState = {
    match_cricket_list: {},
    match_football_list: {},
    pool_list: {},
    pool_detail: {},
    match_contest_player_list: {},
    saveTeam: {},
    my_contests: {},
    my_picks: {},
    contest_prize_preview: {},
    join_contest: {},
    privateContestWinnerList: {},
    createPrivateContest: {},
    clone_my_picks: {},
    edit_picks_save: {},
    contest_player_id: {},
    match_my_portfolio: {},
    banner_list: {},
    match_result: {},
    myleaderboard_player: {},
    match_player_selected: {}
    
};

const matchSlice = createSlice({
    name: "match",
    initialState,
    reducers: {
        RemoveMatchCricketListing: (state) => {
            state.match_cricket_list = {};
        },
        RemoveMatchFootballListing: (state) => {
            state.match_football_list = {};
        },
        ResetPoolListData: (state) => {
            state.pool_list = {};
        },
        ResetPoolDetailData: (state) => {
            state.pool_detail = {};
        },
        ResetContestPlayerList: (state) => {
            state.match_contest_player_list = {};
        },
        ResetMyContestData: (state) => {
            state.my_contests = {};
        },
        ResetMyPicksData: (state) => {
            state.my_picks = {};
        },
        ResetContestPrizePreView: (state) => {
            state.contest_prize_preview = {};
        },
        ResetJoinContest: (state) => {
            state.join_contest = {};
        },
        ResetContestWinnerList: (state) => {
            state.privateContestWinnerList = {}
        },
        ResetCreateContest: (state) => {
            state.createPrivateContest = {}
        },
        ResetCloneMyPicks : (state) => {
            state.clone_my_picks = {}
        },
        ResetEditPicksSaveData : (state) => {
            state.edit_picks_save = {}
        },
        ResetContestPlayerId: (state) => {
            state.contest_player_id = {}
        },
        ResetMatchMyPortfolioList: (state) => {
            state.match_my_portfolio = {}
        },
        ResetBannerListAction: (state) => {
            state.banner_list = {}
        },
        ResetSaveTeamAction: (state) => {
            state.saveTeam = {}
        },
        ResetMatchResult: (state) => {
            state.match_result = {};
        },
        ResetMyLeaderBoardPlayerList: (state) => {
            state.myleaderboard_player = {};
        },
        ResetMatchPlayerSelected: (state) => {
            state.match_player_selected = {};
        },
    },
    extraReducers: {
        [MatchCricketListingAsyncCall.pending]: (state) => {
            return { ...state, loading: true };
        },
        [MatchCricketListingAsyncCall.fulfilled]: (state, { payload }) => {
            return { ...state, match_cricket_list: payload, loading: false };
        },
        [MatchCricketListingAsyncCall.rejected]: (state) => {
            return { ...state, loading: false };
        },

        [MatchFootballListingAsyncCall.pending]: (state) => {
            return { ...state, loading: true };
        },
        [MatchFootballListingAsyncCall.fulfilled]: (state, { payload }) => {
            return { ...state, match_football_list: payload, loading: false };
        },
        [MatchFootballListingAsyncCall.rejected]: (state) => {
            return { ...state, loading: false };
        },

        [PoolContestAsyncList.pending]: (state) => {
            return { ...state, loading: true };
        },
        [PoolContestAsyncList.fulfilled]: (state, { payload }) => {
            return { ...state, pool_list: payload, loading: false };
        },
        [PoolContestAsyncList.rejected]: (state) => {
            return { ...state, loading: false };
        },

        [PoolContestDetailAsyncList.pending]: (state) => {
            return { ...state, loading: true };
        },
        [PoolContestDetailAsyncList.fulfilled]: (state, { payload }) => {
            return { ...state, pool_detail: payload, loading: false };
        },
        [PoolContestDetailAsyncList.rejected]: (state) => {
            return { ...state, loading: false };
        },

        [MatchPlayerAsyncList.pending]: (state) => {
            return { ...state, loading: true };
        },
        [MatchPlayerAsyncList.fulfilled]: (state, { payload }) => {
            return { ...state, match_contest_player_list: payload, loading: false };
        },
        [MatchPlayerAsyncList.rejected]: (state) => {
            return { ...state, loading: false };
        },

        [ContestSaveTeamAction.pending]: (state) => {
            return { ...state, loading: true };
        },
        [ContestSaveTeamAction.fulfilled]: (state, { payload }) => {
            return { ...state, saveTeam: payload, loading: false };
        },
        [ContestSaveTeamAction.rejected]: (state) => {
            return { ...state, loading: false };
        },

        [MyContestListAction.pending]: (state) => {
            return { ...state, loading: true };
        },
        [MyContestListAction.fulfilled]: (state, { payload }) => {
            return { ...state, my_contests: payload, loading: false };
        },
        [MyContestListAction.rejected]: (state) => {
            return { ...state, loading: false };
        },

        [ContestsMypicks.pending]: (state) => {
            return { ...state, loading: true };
        },
        [ContestsMypicks.fulfilled]: (state, { payload }) => {
            return { ...state, my_picks: payload, loading: false };
        },
        [ContestsMypicks.rejected]: (state) => {
            return { ...state, loading: false };
        },

        [ContestPrizePreviewAction.pending]: (state) => {
            return { ...state, loading: true };
        },
        [ContestPrizePreviewAction.fulfilled]: (state, { payload }) => {
            return { ...state, contest_prize_preview: payload, loading: false };
        },
        [ContestPrizePreviewAction.rejected]: (state) => {
            return { ...state, loading: false };
        },

        [JoinContestAction.pending]: (state) => {
            return { ...state, loading: true };
        },
        [JoinContestAction.fulfilled]: (state, { payload }) => {
            return { ...state, join_contest: payload, loading: false };
        },
        [JoinContestAction.rejected]: (state) => {
            return { ...state, loading: false };
        },

        [PrivateContestWinnersList.pending]: (state) => {
            return { ...state, loading: true };
        },
        [PrivateContestWinnersList.fulfilled]: (state, { payload }) => {
            return { ...state, privateContestWinnerList: payload, loading: false };
        },
        [PrivateContestWinnersList.rejected]: (state) => {
            return { ...state, loading: false };
        },

        [CreatePrivatecontest.pending]: (state) => {
            return { ...state, loading: true };
        },
        [CreatePrivatecontest.fulfilled]: (state, { payload }) => {
            return { ...state, createPrivateContest: payload, loading: false };
        },
        [CreatePrivatecontest.rejected]: (state) => {
            return { ...state, loading: false };
        },
        [SearchPrivatecontest.pending]: (state) => {
            return { ...state, loading: true };
        },
        [SearchPrivatecontest.fulfilled]: (state, { payload }) => {
            return { ...state, createPrivateContest: payload, loading: false };
        },
        [SearchPrivatecontest.rejected]: (state) => {
            return { ...state, loading: false };
        },

        [CloneMyPicksAction.pending]: (state) => {
            return { ...state, loading: true };
        },
        [CloneMyPicksAction.fulfilled]: (state, { payload }) => {
            return { ...state, clone_my_picks: payload, loading: false };
        },
        [CloneMyPicksAction.rejected]: (state) => {
            return { ...state, loading: false };
        },

        [EditPicksSaveAction.pending]: (state) => {
            return { ...state, loading: true };
        },
        [EditPicksSaveAction.fulfilled]: (state, { payload }) => {
            return { ...state, edit_picks_save: payload, loading: false };
        },
        [EditPicksSaveAction.rejected]: (state) => {
            return { ...state, loading: false };
        },

        [getPlayerListIDAction.pending]: (state) => {
            return { ...state, loading: true };
        },
        [getPlayerListIDAction.fulfilled]: (state, { payload }) => {
            return { ...state, contest_player_id: payload, loading: false };
        },
        [getPlayerListIDAction.rejected]: (state) => {
            return { ...state, loading: false };
        },

        [ContestMyPortfolioAction.pending]: (state) => {
            return { ...state, loading: true };
        },
        [ContestMyPortfolioAction.fulfilled]: (state, { payload }) => {
            return { ...state, match_my_portfolio: payload, loading: false };
        },
        [ContestMyPortfolioAction.rejected]: (state) => {
            return { ...state, loading: false };
        },

        [GetBannerListAction.pending]: (state) => {
            return { ...state, loading: true };
        },
        [GetBannerListAction.fulfilled]: (state, { payload }) => {
            return { ...state, banner_list: payload, loading: false };
        },
        [GetBannerListAction.rejected]: (state) => {
            return { ...state, loading: false };
        },

        [MatchResultScoreAction.pending]: (state) => {
            return { ...state, loading: true };
        },
        [MatchResultScoreAction.fulfilled]: (state, { payload }) => {
            return { ...state, match_result: payload, loading: false };
        },
        [MatchResultScoreAction.rejected]: (state) => {
            return { ...state, loading: false };
        },


        [MatchMyLeaderBoardPlayerListAction.pending]: (state) => {
            return { ...state, loading: true };
        },
        [MatchMyLeaderBoardPlayerListAction.fulfilled]: (state, { payload }) => {
            return { ...state, myleaderboard_player: payload, loading: false };
        },
        [MatchMyLeaderBoardPlayerListAction.rejected]: (state) => {
            return { ...state, loading: false };
        },


        [MatchSelectedPlayersAction.pending]: (state) => {
            return { ...state, loading: true };
        },
        [MatchSelectedPlayersAction.fulfilled]: (state, { payload }) => {
            return { ...state, match_player_selected: payload, loading: false };
        },
        [MatchSelectedPlayersAction.rejected]: (state) => {
            return { ...state, loading: false };
        },
    }
})

export const { RemoveMatchCricketListing, RemoveMatchFootballListing, ResetPoolListData, ResetContestPlayerList, ResetMyContestData, ResetPoolDetailData, ResetMyPicksData, ResetContestPrizePreView, ResetJoinContest, ResetContestWinnerList, ResetCreateContest, ResetContestPlayerId, ResetCloneMyPicks, ResetMatchMyPortfolioList, ResetBannerListAction, ResetSaveTeamAction, ResetMatchResult, ResetMyLeaderBoardPlayerList } = matchSlice.actions;
export const getCricketMatchListingData = (state) => state.match.match_cricket_list;
export const getFootballMatchListingData = (state) => state.match.match_football_list;
export const getPoolListData = (state) => state.match.pool_list;
export const getPoolDetailsData = (state) => state.match.pool_detail
export const getContestPlayerListData = (state) => state.match.match_contest_player_list;
export const getSaveTeamData = (state) => state.match.saveTeam;
export const getMyContestList = (state) => state.match.my_contests;
export const getMyPicksData = (state) => state.match.my_picks;
export const getPrizePreviewData = (state) => state.match.contest_prize_preview;
export const getJoinContestData = (state) => state.match.join_contest;
export const getPrivateWinnerList = (state) => state.match.privateContestWinnerList;
export const getCreateContestData = (state) => state.match.createPrivateContest;
export const getClonePicksData = (state) => state.match.clone_my_picks;
export const getEditPicksSaveData = (state) => state.match.edit_picks_save;
export const getPlayerIdData = (state) => state.match.contest_player_id;
export const getPortfolioList = (state) => state.match.match_my_portfolio; 
export const getBannerList = (state) => state.match.banner_list; 
export const getMatchResult = (state) => state.match.match_result;
export const getMyLeaderBoardPlayerList = (state) => state.match.myleaderboard_player;
export const getMatchPlayerSelected = (state) => state.match.match_player_selected;
export default matchSlice.reducer;
